export enum VisibleConnectionStatus {
    // Socket is connected, no visual indicators are shown
    connected = 'connected',
    // Socket is disconnected, but the user is logged out, so no visual indicators are shown
    idle = 'idle',
    // The socket is disconnected, and a "reconnecting" overlay & spinner will be shown
    disconnected = 'disconnected',
    // The socket isn't currently connected, but it's attempting to connect, no visual indicators are shown
    //  This is used on initialisation, so we don't show a spinner unnecessarily
    connecting = 'connecting',
    // The socket isn't connected - a "Trying to reconnect" status message will be shown
    interrupted = 'interrupted',
}

export const VISIBLE_CONNECTION_STATUS_CHANGED = 'VISIBLE_CONNECTION_STATUS_CHANGED';
